import React,{ useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import Footer from './components/footer/Footer'

import HeaderWrapper from './components/agent-header/HeaderWrapper'
import { MenuComponent } from '../assets/ts/components/MenuComponent'

const AgentLayout = () => {

    const location = useLocation()
    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization()
        }, 500);
    }, [location.key])

    useEffect(() => {
        document.body.setAttribute('data-sai-app-sidebar-hoverable', 'false')
        document.body.setAttribute('data-sai-app-sidebar-push-header', 'false')
        document.body.setAttribute('data-sai-app-sidebar-push-toolbar', 'false')
        document.body.setAttribute('data-sai-app-sidebar-push-footer', 'false')
        document.body.setAttribute('data-sai-app-sidebar-enabled', 'false')
        document.body.setAttribute('data-sai-app-sidebar-fixed', 'false')
        document.body.setAttribute('data-sai-app-toolbar-enabled', 'false')
    }, [])


    return (
        <>
            <div className='d-flex flex-column flex-root app-root'>
                <div className='app-page flex-column flex-column-fluid'>
                    <HeaderWrapper />
                    <div className='app-wrapper flex-column flex-row-fluid'>
                        <div className='d-flex flex-column flex-row-fluid vh-90'>
                            <div className='d-flex flex-column flex-column-fluid flex-grow-1'>
                                <div className="app-content flex-column-fluid">
                                    <div className="app-container container-xxl">
                                        <Outlet />
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AgentLayout